// File: components/eventsSectionsComponents/EventsHeroSection.jsx

import React, { useEffect, useState } from "react";
import "./EventsHeroSection.css";
import { useNavigate } from "react-router-dom";

// Background images
import heroImage1 from "../../Assets/images/tobeused.jpg";
import heroImage2 from "../../Assets/images/inner1.jpg";
import heroImage3 from "../../Assets/images/inner2.jpg";
import heroImage4 from "../../Assets/images/ripplerun.jpg";
import heroImage5 from "../../Assets/images/ripplerun2.jpg";
import eventFlyer from "../../Assets/storyfest/flyer2.jpeg"; 

const backgrounds = [heroImage1, heroImage4, heroImage5, heroImage2, heroImage3];

export default function EventsHeroSection() {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (prevIndex === backgrounds.length - 1) {
          return 0;
        }
        return prevIndex + 1;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ample-events-hero-section">

      {/* Background Slideshow */}
      <div className="ample-events-hero-slideshow">
        {backgrounds.map((img, index) => (
          <div
            key={index}
            className={
              "ample-events-hero-slide " +
              (index === currentIndex ? "active" : "")
            }
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(12, 8, 6, 0.75),
                  rgba(12, 8, 6, 0.70)
                ),
                url(${img})
              `,
            }}
          />
        ))}
      </div>

      {/* Glow effect */}
      <div className="ample-events-hero-glow" />

      {/* Content Container */}
      <div className="ample-events-hero-container">
        
        {/* LEFT - EVENT FLYER CARD & EXPLORE BUTTON */}
        <div className="ample-events-hero-left">
          <div className="ample-events-flyer-wrapper">
            <div className="ample-events-flyer-container">
              <div className="ample-events-coming-soon-badge">Coming Soon</div>
              <img
                src={eventFlyer}
                alt="Event Flyer"
                className="ample-events-flyer-image"
              />
            </div>

            {/* Flyer Details */}
            <div className="ample-events-flyer-details">
              <div className="ample-events-detail-item">
                <span className="ample-events-detail-icon">📅</span>
                <span>Date: 11th - 13th December 2026</span>
              </div>
              <div className="ample-events-detail-item">
                <span className="ample-events-detail-icon">📍</span>
                <span>Location: Accra City Hotel</span>
              </div>
            </div>

            {/* 👇 Explore Button under the Card */}
            <button
              className="ample-events-hero-explore-btn"
              onClick={() => navigate("/storyfest")}
            >
              Explore StoryFest <span className="ample-events-explore-arrow">↗</span>
            </button>
          </div>
        </div>

        {/* RIGHT - TEXT CONTENT & GET IN TOUCH BUTTON */}
        <div className="ample-events-hero-right">
          <div className="ample-events-hero-content">
            <h1>Ample Events</h1>

            <h3>Elevate leaders through dialogue.</h3>

            <p>
              Develop and engage leaders through transformative learning
              experiences with Ample Events.
            </p>

            <button
              className="ample-events-hero-btn"
              onClick={() => navigate("/contact-us")}
            >
              Get in touch
            </button>
          </div>
        </div>

      </div>

    </section>
  );
}